export const GET_INFO = 'nosotros_traer_info';
export const LOADING = 'nosotros_loading';
export const ERROR = 'nosotros_error';